<h2>{{formLabels['title']}} {{form1.value.name}}</h2>

<form [formGroup]="form1">
  <mat-tab-group> <mat-tab label="User Role">
    <div class="form-section">
      <h3>User Role</h3>

      @if (('form1.value.userRoleId')) {
        <mat-form-field> <input
          matInput
          placeholder="UserRoleId"
          [value]="form1.value.userRoleId"
        readonly="true"> </mat-form-field>
      }


      @if (('form1.value.createDate')) {
        <mat-form-field> <input
          matInput
          placeholder="Created"
          [value]="form1.value.createDate"
        readonly="true"> </mat-form-field>
      }

      <mat-form-field> <input
        matInput
        placeholder="Name"
        formControlName="name"
        readonly="{{formReadOnly}}"> @for (validation of validationMessages.name; track validation) {
        <mat-error> @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
          <mat-error
            class="error-message"
          > {{validation.message}}</mat-error>
        } </mat-error>
      } </mat-form-field>


      <mat-form-field> <input
        matInput
        placeholder="Description"
        formControlName="description"
        readonly="{{formReadOnly}}"> @for (validation of validationMessages.description; track validation) {
        <mat-error> @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
          <mat-error
            class="error-message"
          > {{validation.message}}</mat-error>
        } </mat-error>
      } </mat-form-field>
    </div>
    <br />
    </mat-tab> <mat-tab label="History"> <app-audit-list [auditUrl]="'user-roles/' + this.userRoleId + '/audit'"></app-audit-list> </mat-tab> </mat-tab-group>
    @if (formAction.includes('add')) {
      <button
        mat-raised-button
        color="primary"
        (click)="formAdd()"
      [disabled]="!form1.valid">Add</button>
    }
    @if (formAction.includes('add')) {
      <button
        mat-button
        type="reset"
      (click)="this.form1.reset()">Clear</button>
    }
    @if (formAction.includes('add')) {
      <button
        mat-button
        type="button"
      (click)="routerLocation.back()">Cancel</button>
    }

    @if (formAction.includes('edit')) {
      <button
        mat-raised-button
        color="primary"
        (click)="formUpdate()"
      [disabled]="!form1.valid">Update</button>
    }
    @if (formAction.includes('edit')) {
      <button
        mat-button
        type="button"
      [routerLink]="['/user-role-view', form1.value.userRoleId]">Cancel</button>
    }

    @if (formAction.includes('view')) {
      <button
        mat-raised-button
        color="primary"
      [routerLink]="['/user-role-edit', form1.value.userRoleId]">Edit</button>
    }
    @if (formAction.includes('view')) {
      <button
        mat-button
        type="button"
      [routerLink]="['/user-role-list']">Done</button>
    }

    @if (formLoading) {
      <img
        class="pl-3"
		src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
}
</form>
